import React, { useEffect, useMemo, useState } from "react";
import { read } from "../../DataApi/read";
import { useSession } from "../../authentications/SessionContext";
import styled from "styled-components";
import TableHeader from "../Table/TableHeader";
import TableBodyWithInputs from "../Table/TableBodyWithInputs";
import { FieldArray, Form, Formik } from "formik";
import { callButtonGeneral } from "../../DataApi/generalApis/callButtonGeneral";
import { customAPI } from "../../DataApi/generalApis/customAPI";
import { enqueueSnackbar } from "notistack";
import { deliveryInfoDetailValidationSchema } from "../../utilities/Validation Schema/deliveryInfoDetailValidationSchema";
import { handleResponse } from "../../utilities/handleResponse";
import useConfirmationModal from "../ConfirmationModal/useConfirmationModal";

const TableButton = styled.button`
  background-color: #f8f9fa;
  color: #b0b7c3;
  border: none;
  border-radius: 15px;
  padding: 10px 20px;
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-weight: 600;

  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;

  background-color: #ff5837;
  color: #fff;
  &:hover,
  &:focus,
  &:active {
    background-color: #ff5837;
    color: #fff;
  }
`;
const TableContainer = styled.div`
  width: 100%;
  background-color: #fff;
  border-radius: 15px;
  padding: 13px;
  overflow-auto
`;
const Button = styled.button`
  background-color: #f8f9fa;
  color: #b0b7c3;
  width: 280px;
  min-width: 160px;
  border: none;
  border-radius: 15px;
  padding: 10px 20px;
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-weight: 600;

  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;

  &:hover,
  &:focus,
  &:active {
    background-color: #ff5837;
    color: #fff;
  }
`;
function DeliveryInfoDetail({
  selectedDeliveryOrder,
  handleCloseDeliveryInfoDetailModal,
  handleGetDeliveryOrders,
}) {
  const { sessionInfo } = useSession();
  const { company_id, context } = sessionInfo;
  const { setMetaData, ConfirmationModal, setTitle, setOpenModal } =
    useConfirmationModal();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoadingData, setIsLoadingData] = useState(true);

  const [selectedDeliveryOrderDetail, setSelectedDeliveryOrderDetail] =
    useState({});
  const [selectedDeliveryProductLines, setselectedDeliveryProductLines] =
    useState([]);

  const handleGetDeliveryLineWithoutPackage = async (deliveryOrder) => {
    let response = await read({
      change: [
        "product_id",
        "company_id",
        "move_id",
        "picking_id",
        "product_uom_category_id",
        "location_id",
        "location_dest_id",
        "package_id",
        "result_package_id",
        "lots_visible",
        "owner_id",
        "state",
        "lot_id",
        "lot_name",
        "is_initial_demand_editable",
        "product_uom_qty",
        "is_locked",
        "qty_done",
        "product_uom_id",
      ],
      company_id,
      context,
      id: deliveryOrder.move_line_ids_without_package,
      model: "stock.move.line",
    });
    response = JSON.parse(response);
    if (response.result) {
      setselectedDeliveryProductLines(
        response.result.map((item) => {
          // console.log(item, "asasassa");
          return {
            ...item,
            // product_uom_qty:
            //   item?.state === "done" ? item.qty_done : item.product_uom_qty,
            qty_done:
              item?.state === "done"
                ? item?.qty_done || 0
                : item?.product_uom_qty || 0,
            product_name: item.product_id[1],
            // product_id:item.product_id
          };
        }) || []
      );
    }
  };
  const handleGetDeliveryOrderDetail = async () => {
    try {
      let response = await read({
        change: [
          "is_locked",
          "show_mark_as_todo",
          "show_check_availability",
          "show_validate",
          "show_lots_text",
          "immediate_transfer",
          "picking_type_code",
          "hide_picking_type",
          "show_operations",
          "show_reserved",
          "move_line_exist",
          "has_packages",
          "picking_type_entire_packs",
          "use_create_lots",
          "state",
          "has_scrap_move",
          "has_tracking",
          "priority",
          "name",
          "partner_id",
          "picking_type_id",
          "location_id",
          "location_dest_id",
          "backorder_id",
          "scheduled_date",
          "json_popover",
          "date_deadline",
          "date_done",
          "origin",
          "owner_id",
          "move_line_nosuggest_ids",
          "package_level_ids_details",
          "move_line_ids_without_package",
          "move_ids_without_package",
          "id",
          "package_level_ids",
          "is_return_picking",
          "carrier_id",
          "delivery_type",
          "carrier_tracking_ref",
          "weight",
          "weight_uom_name",
          "asyad_no_return",
          "shipping_weight",
          "move_type",
          "user_id",
          "group_id",
          "website_id",
          "company_id",
          "note",
          "message_follower_ids",
          "activity_ids",
          "message_ids",
          "display_name",
        ],
        company_id,
        context,
        id: selectedDeliveryOrder,
        model: "stock.picking",
      });
      response = JSON.parse(response);
      if (response.result) {
        // check availability
        await callButtonGeneral({
          method: "action_assign",
          model: "stock.picking",
          company_id,
          context: { ...context },
          args: selectedDeliveryOrder,
        });
        setSelectedDeliveryOrderDetail(response?.result?.[0] || {});
        setIsLoadingData(false);
        handleGetDeliveryLineWithoutPackage(response?.result[0]);
      } else {
        enqueueSnackbar("Somthing Went Wrond", { variant: "error" });
      }
    } catch (error) {
      setIsLoadingData(false);
    }
  };

  const handleDeliveryConfirmation = async ({ values }) => {
    setIsSubmitting(true);
    let orderLines = values?.order_line || [];
    // if (selectedDeliveryOrderDetail?.state === "done") {
    //   orderLines = orderLines.map((order) => ({
    //     ...order,
    //     product_uom_qty: 0,
    //   }));
    // }
    const response = await callButtonGeneral({
      company_id,
      method:
        selectedDeliveryOrderDetail?.state === "done"
          ? "mp_process_do_return"
          : "mp_process_do",
      model: "stock.picking",
      args: [`${values.id}`, orderLines],
      context,
    });
    setIsSubmitting(false);
    if (response.result) {
      handleCloseDeliveryInfoDetailModal();
      handleGetDeliveryOrders();
      // enqueueSnackbar("Delivery Order Updated", { variant: "success" });
      return;
    }
    setOpenModal(true);
    handleResponse({
      response,
      setMetaData,
      setTitle,
      successMessage: "Delivery Updated",
    });
  };

  useEffect(() => {
    if (selectedDeliveryProductLines?.length === 0) setIsLoadingData(true);
    handleGetDeliveryOrderDetail();
  }, []);
  const deliverOrderProductLinesList = useMemo(
    () => [
      {
        title: "Product",
        name: "product_name",
        disableInput: true,
      },
      // {
      //   title: "Demand",
      //   name: "product_uom_qty",
      //   disableInput: true,
      //   type: "number",
      // },
      {
        title: "Done",
        name: "qty_done",
        type: "number",
        disableInput: true,
      },
    ],
    []
  );
  return (
    <>
      <ConfirmationModal />
      <div className="">
        <h3
          className="m-3"
          style={{
            fontFamily: "Inter",
            color: "#323B4B",
            fontWeight: 600,
          }}
        >
          {selectedDeliveryOrderDetail?.state === "done"
            ? "Return Order"
            : "Delivery Order"}
        </h3>
      </div>
      <Formik
        enableReinitialize
        initialValues={{
          id: selectedDeliveryOrder,
          order_line: selectedDeliveryProductLines || [],
        }}
        validationSchema={deliveryInfoDetailValidationSchema}
        // onSubmit={handleDeliConfirmationModalveryConfirmation}
      >
        {({ values, validateForm, setErrors }) => (
          <Form>
            <TableContainer className="overflow-auto">
              <table className="table">
                <TableHeader tableHeaderList={deliverOrderProductLinesList} />

                <FieldArray
                  name="order_line"
                  render={({ ...props }) => (
                    <TableBodyWithInputs
                      {...props}
                      tableBodyList={deliverOrderProductLinesList}
                      isLoadingData={isLoadingData}
                      handleRowClick={(data, index) => {
                        //   setSelectedDeliveryOrder(data.id);
                      }}
                    />
                  )}
                />
              </table>
              <div className="d-flex justify-content-end mx-4">
                <TableButton
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDeliveryConfirmation({
                      values,
                      validateForm,
                      setErrors,
                    });
                  }}
                  disabled={isSubmitting}
                >
                  {isSubmitting
                    ? "Loading..."
                    : selectedDeliveryOrderDetail?.state === "done"
                    ? "Return"
                    : "Confirm"}
                </TableButton>
              </div>
            </TableContainer>
          </Form>
        )}
      </Formik>
    </>
  );
}

export default DeliveryInfoDetail;
